<template>
  <div id="about_nav">
    <div class="nav-top">
      <div class="top-box">
        <h3>关于我们</h3>
        <p>About us</p>
      </div>
    </div>
    <div class="nav-box">
      <div class="nav-bottom">
        <div class="seat-box">
          <h3>
            您的位置：首页 > 关于我们 >
            <span>爱眼简介</span>
          </h3>
          <div :class="{'border-box':classShow, 'animated': classHide, 'fadeInUpBig': classHide}"></div>
        </div>
        <ul>
          <li
            v-for="(item,index) in navList"
            :key="index"
            @click="getStyle(item.id)"
            :class="{active:liStatus==item.id}"
          >{{item.title}}</li>
        </ul>
      </div>
    </div>
    <div class="nav-content">
      <about-intd v-show="navShow==1"></about-intd>
      <about-council v-show="navShow==3"></about-council>
      <about-partner v-show="navShow==5"></about-partner>
    </div>
  </div>
</template>
<script>
import aboutIntd from "./about_intd";
import aboutCouncil from "./about_council";
import aboutPartner from "./about_partner";

export default {
  components: {
    aboutIntd,
    aboutCouncil,
    aboutPartner
  },
  data() {
    return {
      classShow: true,
      classHide: false,
      navShow:1,
      navList: [
        {
          id: 1,
          title: "爱眼简介"
        },
        {
          id: 2,
          title: "爱眼章程"
        },
        {
          id: 3,
          title: "理事会成员"
        },
        {
          id: 4,
          title: "大事记"
        },
        {
          id: 5,
          title: "合作伙伴"
        },
        {
          id: 6,
          title: "联系我们"
        }
      ],
      liStatus: 1
    };
  },
  methods: {
    getStyle(id) {
      this.liStatus = id;
      this.navShow = id;
    }
  }
};
</script>
<style lang="scss" scoped>
#about_nav {
  width: 100%;
}
.nav-top {
  width: 100%;
  height: 300px;
  background: url(../../assets/images/nav_bg.png) no-repeat;
  background-size: 100% 100%;
  .top-box {
    width: 1300px;
    margin: 0 auto;
    padding-top: 118px;
    > h3 {
      font-size: 36px;
      color: #333333;
      font-weight: normal;
    }
    > p {
      font-size: 26px;
      font-weight: normal;
      color: #999999;
    }
  }
}
.nav-box {
  width: 1300px;
  margin: 0 auto;
  // margin-bottom: 86px;
  .nav-bottom {
    width: 100%;
    .seat-box {
      > h3 {
        font-size: 14px;
        color: #999;
        text-align: right;
        font-weight: normal;
        padding: 28px 0 17px;
        > span {
          color: #333333;
        }
      }
      .border-box {
        width: 1300px;
        height: 1px;
        border: 1px solid #c30d23;
        border-bottom: 3px solid #c30d23;
      }
    }
    > ul {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      > li {
        list-style: none;
        padding: 15px 25px;
        font-size: 18px;
        color: #000000;
        cursor: pointer;
        &.active {
          // background-color: #fff;
          background-color: #c30d23;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About/about_nav.vue